var map = {
	"./Aquarius.svg": 366,
	"./Aries.svg": 367,
	"./Cancer.svg": 368,
	"./Capricorn.svg": 369,
	"./Gemini.svg": 370,
	"./Leo.svg": 371,
	"./Libra.svg": 372,
	"./Pisces.svg": 373,
	"./Sagittarius.svg": 374,
	"./Scorpio.svg": 375,
	"./Taurus.svg": 376,
	"./Virgo.svg": 377
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/horoscope_icon ^\.\/.*\.svg$
// module id = 120
// module chunks = 0